import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import styles from './BookCover.module.css';

export interface BookCoverProps {
  coverUrl?: string | null;
  title?: string | null;
  className?: string;
}

export function BookCover({ coverUrl, title, className }: BookCoverProps): ReactNode {
  const rootClassName = className ? `${styles.root} ${className}` : styles.root;

  if (coverUrl) {
    return (
      <Box className={rootClassName}>
        <img
          src={coverUrl}
          alt={title || 'Обложка книги'}
          className={styles.image}
        />
      </Box>
    );
  }

  return (
    <Box className={rootClassName}>
      <Box className={styles.placeholder}>Нет обложки</Box>
    </Box>
  );
}

